"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _downloadUrl = _interopRequireDefault(require("../../../../utils/downloadUrl"));

var _customProps = require("../../../../utils/customProps");

var _Button = _interopRequireDefault(require("../Button/Button"));

/**
 * ButtonDownload onClick bug is opening url in a new tab in the browser instead of dowloading.
 * More docs and demos at https://material-ui.com/api/button/
 */
// TODO: BUG not downloading
var ButtonDownload = function ButtonDownload(_ref) {
  var button = _ref.button,
      href = _ref.href,
      fileName = _ref.fileName,
      callback = _ref.callback;

  var onClick = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (callback) callback();
              (0, _downloadUrl.default)(href, fileName);

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onClick() {
      return _ref2.apply(this, arguments);
    };
  }();

  var muibutton = button[0];
  return /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({}, muibutton, {
    onClick: onClick
  }));
};

var _default = ButtonDownload;
exports.default = _default;
ButtonDownload.propTypes = {
  /** MuiButton Allowed maximum: 1 */
  button: function button(props, propName, componentName) {
    var components = ['Button'];
    return (0, _customProps.validComponents)(props, propName, componentName, components, 1);
  },

  /** url of the file you want to be downloaded */
  href: _propTypes.default.string.isRequired,

  /** name of file */
  fileName: _propTypes.default.string.isRequired,
  // callback to run before download
  callback: _propTypes.default.func
};
ButtonDownload.defaultProps = {
  button: [],
  callback: undefined
};